import React from 'react';
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase'

import { useSelector } from 'react-redux'
import Chat from  '../Chat/Chat'


// ---------------------
// Component 
// ---------------------

const ChatInterface = ({room, isAdmin, auth}) => {

    // -----------------------
    // Firestore
    // -----------------------

    // Load Chatroom
    const messagesId = room+'-messages'
    const blockedId = room+'-blocked'

    // Subscribe to Messages
    useFirestoreConnect({
        collection: 'chatrooms',
        doc: room,
        subcollections: [
            { 
                collection: 'messages',
                orderBy: 'createdAt'
            }
        ],
        storeAs: messagesId,
    }) 

    const messages = useSelector(state => {
        if(!state.firestore.data[messagesId]) return null;
        return state.firestore.data[messagesId]
    });
    
    // Subscribe to Blocked List
    useFirestoreConnect({
        collection: 'chatrooms',
        doc: room,
        subcollections: [
            { 
                collection: 'blocked',
                orderBy: 'createdAt'
            }
        ],
        storeAs: blockedId,
    }) 
        
    

    const blocked = useSelector(state => {
        if(!state.firestore.data[blockedId]) return null;
        return state.firestore.data[blockedId]
    });

    // ------------------------
    // Router
    // ------------------------

    // Not Loaded
    if (!isLoaded(messages)) return (<div>Loading...</div>);

    // Show Chat
    return (
        <Chat room={room} auth={auth} messages={messages} isAdmin={isAdmin} blocked={blocked} />
    )

}

export default ChatInterface;
